/// <amd-module name="Dashboards/DashboardView/src/utilities/DashboardModelConverter" />
import { Dashboard } from "../model/Dashboard";
import { Widget } from "../model/Widget";

import { Dashboard as ServerDashboard } from "Dashboards/Common/Contracts/Dashboard";

export function copyWidgetsFromServerData(serverDashboard: ServerDashboard): ReadonlyArray<Widget> {
    const widgets: ReadonlyArray<Widget> = serverDashboard.widgets.map(widget => {
        // Note: This step FILTERS the full Widget Contract into simplified modern representation
        return {
            id: widget.id,
            name: widget.name,
            size: widget.size,
            position: widget.position,
            settings: widget.settings,
            settingsVersion: widget.settingsVersion,
            contributionId: widget.contributionId,
            configurationContributionId: widget.configurationContributionId,
            areSettingsBlockedForUser: widget.areSettingsBlockedForUser,
            isNameConfigurable: widget.isNameConfigurable,
            isEnabled: widget.isEnabled,
            eTag: widget.eTag
        };
    });
    return widgets;
}

export function copyDashboardFromServerData(serverDashboard: ServerDashboard): Dashboard {
    const dashboard: Dashboard = {
        id: serverDashboard.id,
        name: serverDashboard.name,
        description: serverDashboard.description,
        groupId: serverDashboard.groupId,
        ownerId: serverDashboard.ownerId,
        dashboardScope: serverDashboard.dashboardScope,
        refreshInterval: serverDashboard.refreshInterval,
        eTag: serverDashboard.eTag,
        lastAccessedDate: serverDashboard.lastAccessedDate,
        modifiedBy: serverDashboard.modifiedBy,
        modifiedDate: serverDashboard.modifiedDate
    };

    return dashboard;
}

export function combineStatePiecesIntoDashboard(dashboard: Dashboard, widgets: ReadonlyArray<Widget>): ServerDashboard {
    return {
        ...dashboard,
        widgets: widgets.slice()
    } as ServerDashboard;
}
